"use client";

import { useBreakpoint } from '@hooks';
import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import "react-multi-carousel/lib/styles.css";
import { CarouselLeftArrow } from './CarouselLeftArrow';
import { CarouselRightArrow } from './CarouselRightArrow';

const Carousel = dynamic(() => import('react-multi-carousel'), { ssr: false });

export function CustomCarousel({ desktopItems = 1, tabletItems = 1, mobileItems = 1, autoPlay, content, dotColor }) {

    const deviceType = useBreakpoint();

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: desktopItems
        },
        tablet: {
            breakpoint: { max: 1023, min: 640 },
            items: tabletItems
        },
        mobile: {
            breakpoint: { max: 639, min: 350 },
            items: mobileItems
        }
    };


    const carouselRef = useRef(null);
    const [isInView, setIsInView] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsInView(entry.isIntersecting);
            },
            {
                threshold: 0.5
            }
        );

        if (carouselRef.current) {
            observer.observe(carouselRef.current);
        }

        return () => {
            if (carouselRef.current) {
                observer.unobserve(carouselRef.current);
            }
        };
    }, []);



    const CustomDot = ({ onClick, ...rest }) => {
        const { active } = rest;
        const dotColorBg = dotColor === "green" ? `${active ? "bg-emerald-700" : "bg-emerald-400"}` : `${active ? "bg-zinc-400" : "bg-white"}`;
        return (
            <button
                className={`mx-4 size-2 rounded-full ${dotColorBg}`}
                onClick={onClick}
            >
            </button>
        );
    };

    const isDesktop = deviceType === "desktop";

    return (
        <div ref={carouselRef} className="relative w-full">
            <Carousel
                swipeable={!isDesktop}
                draggable={false}
                minimumTouchDrag={30}
                showDots={true}
                responsive={responsive}
                ssr={false}
                infinite={false}
                autoPlay={autoPlay ? (isDesktop && isInView) ? true : false : false}
                autoPlaySpeed={3000}
                keyBoardControl={true}
                transitionDuration={300}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={deviceType}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
                customLeftArrow={<CarouselLeftArrow />}
                customRightArrow={<CarouselRightArrow />}
                customDot={<CustomDot />}
            >
                {content}
            </Carousel>
        </div>
    )
}
